export default "<span class=\"letters\">\n  {{ initials }}\n</span>\n";